// @ts-nocheck

import React, { useMemo, useContext } from 'react';
import { Group, Image, Rect } from 'react-konva';

import Formatter from '../../../i18n/formatter';
import { __ } from '../../../i18n/l10n';
import { BetslipEntity } from '../../../states/entities/betslips';
import BetshareContext from '../contexts/BetshareContext';
import { getRelativeValue } from '../utils';

import ScalableText from './ScalableText';

const Header = (props) => {
  const { x, y, validationDate, forwardRef, type, nickname, showPseudo } = props;
  const {
    images: { logoWina },
    stageWidth,
  } = useContext(BetshareContext);

  const text = useMemo(
    () =>
      showPseudo && nickname
        ? __("%1$s's bet", nickname).toUpperCase()
        : BetslipEntity.getTypeLabel(type).toUpperCase(),
    [nickname, showPseudo, type],
  );
  return (
    <Group x={x} y={y} ref={forwardRef}>
      <Rect x={0} y={0} width={stageWidth} height={getRelativeValue(58, stageWidth)} fill="#000" />
      <ScalableText
        text={text}
        x={getRelativeValue(70, stageWidth)}
        y={getRelativeValue(11, stageWidth)}
        width={getRelativeValue(240, stageWidth)}
        height={getRelativeValue(25, stageWidth)}
        fontSize={getRelativeValue(25, stageWidth)}
        fontFamily={'BettingPoliticaExtraBoldItalic, sans-serif'}
        fill="#fff"
        verticalAlign="middle"
      />
      <ScalableText
        text={Formatter.formatDate(validationDate, 'longDate').toUpperCase()}
        x={getRelativeValue(70, stageWidth)}
        y={getRelativeValue(36, stageWidth)}
        width={getRelativeValue(240, stageWidth)}
        height={getRelativeValue(18, stageWidth)}
        fontSize={getRelativeValue(13, stageWidth)}
        fontFamily="BettingPoliticaItalic, sans-serif"
        fill="#aaa"
        verticalAlign="middle"
      />
      <Image
        image={logoWina}
        x={getRelativeValue(7, stageWidth)}
        y={getRelativeValue(4, stageWidth)}
        width={getRelativeValue(53, stageWidth)}
        height={getRelativeValue(51, stageWidth)}
      />
    </Group>
  );
};

export default Header;
